(() => {
  const body = document.body;
  if (!body || body.dataset.bransScriptReady === 'true') return;
  body.dataset.bransScriptReady = 'true';

  const phoneQuery = window.matchMedia('(max-width: 989px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let loaderOpeningTimer;
  let loaderHiddenTimer;
  let gifRevealTimer;
  let resizeTimer;
  let navigating = false;

  const numberFromData = (key, fallback) => {
    const value = Number(body.dataset[key]);
    return Number.isFinite(value) ? value : fallback;
  };

  function scheduleGifReveal() {
    window.clearTimeout(gifRevealTimer);
    document.documentElement.classList.remove('brans-gifs-ready');
    if (body.dataset.bransGifEnabled !== 'true') return;
    const delay = numberFromData('bransGifDelay', 0);
    gifRevealTimer = window.setTimeout(() => {
      document.documentElement.classList.add('brans-gifs-ready');
    }, Math.max(0, delay));
  }

  // One CSS animated GIF is rendered in layout/theme.liquid. No random
  // frame selection, background timers, or desktop/mobile GIF swapping.

  function clearLoaderTimers() {
    window.clearTimeout(loaderOpeningTimer);
    window.clearTimeout(loaderHiddenTimer);
  }

  function openLoader() {
    const loader = document.getElementById('BransLoader');
    if (!loader) return;
    clearLoaderTimers();
    loader.classList.remove('is-hidden', 'is-closing');
    loader.classList.add('is-opening');
    loaderHiddenTimer = window.setTimeout(() => loader.classList.add('is-hidden'), 820);
  }

  function playEntry() {
    const loader = document.getElementById('BransLoader');
    if (!loader) return;
    clearLoaderTimers();
    loader.classList.remove('is-hidden', 'is-opening', 'is-closing');
    const hold = Math.max(0, numberFromData('bransLoaderHold', 1000));
    loaderOpeningTimer = window.setTimeout(openLoader, hold);
    loaderHiddenTimer = window.setTimeout(() => loader.classList.add('is-hidden'), hold + (phoneQuery.matches ? 620 : 880));
  }

  function closeThenNavigate(url) {
    const loader = document.getElementById('BransLoader');
    const transitionsEnabled = body.dataset.bransPageTransitionsEnabled === 'true';
    if (!loader || !transitionsEnabled || navigating) {
      window.location.href = url;
      return;
    }
    navigating = true;
    clearLoaderTimers();
    loader.classList.remove('is-hidden', 'is-opening');
    loader.classList.add('is-closing');
    window.setTimeout(() => { window.location.href = url; }, phoneQuery.matches ? 580 : 650);
  }

  function eligibleLink(anchor, event) {
    if (!anchor || !anchor.href || body.dataset.bransPageTransitionsEnabled !== 'true') return false;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download') || anchor.dataset.noBransTransition !== undefined) return false;
    const raw = anchor.getAttribute('href') || '';
    if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return false;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;
    if (anchor.closest('.shopify-payment-button, .shopify-design-mode, #preview-bar-iframe')) return false;
    return true;
  }

  function createWarpStar(index, count, speed, sizeBase) {
    const star = document.createElement('span');
    const angle = (Math.PI * 2 * index) / count + (Math.random() - 0.5) * 0.09;
    const travel = 74 + Math.random() * 36;
    const size = Math.max(0.9, sizeBase * (0.55 + Math.random() * 0.9));
    const duration = Math.max(3.2, speed * (0.8 + Math.random() * 0.85));
    const delay = -Math.random() * duration;
    star.className = 'brans-star brans-star--warp';
    star.style.setProperty('--star-size', `${size.toFixed(2)}px`);
    star.style.setProperty('--star-travel-x', `${(Math.cos(angle) * travel).toFixed(2)}vw`);
    star.style.setProperty('--star-travel-y', `${(Math.sin(angle) * travel).toFixed(2)}vh`);
    star.style.setProperty('--star-duration', `${duration.toFixed(2)}s`);
    star.style.setProperty('--star-delay', `${delay.toFixed(2)}s`);
    star.style.setProperty('--star-tail', `${Math.max(7, size * 6).toFixed(2)}px`);
    star.style.setProperty('--star-tail-height', `${Math.max(.8, size * 0.35).toFixed(2)}px`);
    return star;
  }

  function createFieldStar(mode, speed, sizeBase) {
    const star = document.createElement('span');
    const rarity = Math.random();
    const multiplier = rarity > 0.965
      ? 1.55 + Math.random() * 0.75
      : rarity > 0.76
        ? 0.85 + Math.random() * 0.45
        : 0.48 + Math.random() * 0.34;
    const size = Math.max(0.65, sizeBase * multiplier);
    const opacity = (rarity > 0.94 ? 0.9 + Math.random() * 0.1 : 0.48 + Math.random() * 0.48).toFixed(2);
    const duration = Math.max(6, speed * (0.9 + Math.random() * 1.1));
    star.className = `brans-star brans-star--${mode}`;
    star.style.setProperty('--star-x', `${(Math.random() * 100).toFixed(3)}%`);
    star.style.setProperty('--star-y', `${(Math.random() * 100).toFixed(3)}%`);
    star.style.setProperty('--star-size', `${size.toFixed(2)}px`);
    star.style.setProperty('--star-opacity', opacity);
    star.style.setProperty('--star-duration', `${duration.toFixed(2)}s`);
    star.style.setProperty('--star-delay', `${(-Math.random() * duration).toFixed(2)}s`);
    return star;
  }


  function createRadialStar(index, count, sizeBase) {
    const star = document.createElement('span');

    // Same direction logic as the supplied SCSS: 360 axes snapped every 4 degrees.
    const degrees = index - (index % 4);
    const angle = degrees * (Math.PI / 180);
    const travelX = 80 * Math.cos(angle);
    const travelY = 80 * Math.sin(angle);

    // Same visual sizes as the supplied JavaScript: 1px or 2px.
    const size = Math.random() < 0.5 ? 1 : 2;

    // Same duration range as random(40000) + 5000: 5 to 45 seconds.
    const duration = 5 + Math.random() * 40;
    const opacity = 0.82 + Math.random() * 0.18;

    star.className = 'brans-star brans-star--radial';
    star.style.setProperty('--star-size', `${Math.max(size, Math.min(2, sizeBase)).toFixed(2)}px`);
    star.style.setProperty('--radial-x', `${travelX.toFixed(4)}vw`);
    star.style.setProperty('--radial-y', `${travelY.toFixed(4)}vh`);
    star.style.setProperty('--star-duration', `${duration.toFixed(3)}s`);
    star.style.setProperty('--star-delay', '-30s');
    star.style.setProperty('--star-opacity', opacity.toFixed(2));
    return star;
  }

  function buildStarField() {
    const field = document.getElementById('BransStarField');
    if (!field) return;
    field.replaceChildren();

    const configuredCount = Math.max(1, Math.floor(numberFromData('bransStarCount', 180)));
    const count = phoneQuery.matches ? Math.max(180, Math.round(configuredCount * 0.62)) : configuredCount;
    const requestedMode = body.dataset.bransStarMode || 'warp';
    const mode = requestedMode;
    const speed = Math.max(2, numberFromData('bransStarSpeed', 10));
    const computedSize = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--brans-star-size')) || 2;
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < count; index += 1) {
      if (mode === 'radial') {
        fragment.appendChild(createRadialStar(index, count, computedSize));
      } else if (mode === 'warp') {
        fragment.appendChild(createWarpStar(index, count, speed, computedSize));
      } else {
        fragment.appendChild(createFieldStar(mode, speed, computedSize));
      }
    }
    field.className = `brans-stars--${mode}`;
    field.appendChild(fragment);
  }

  function boot(scope = document) {
    scheduleGifReveal();
    buildStarField();
    playEntry();
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!eligibleLink(anchor, event)) return;
    event.preventDefault();
    closeThenNavigate(anchor.href);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      buildStarField();
    }, 180);
  });

  window.addEventListener('pageshow', (event) => {
    navigating = false;
    if (event.persisted) boot();
  });

})();
